import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { IconAsset } from "../../../../components/icon/Icon";
import React from "react";
import _ from "lodash";
import { LITE_TRADE_POSITION_SIDE } from "../../liteTradeConstants";
import amountFormat from "../../../../utils/amountFormat";
import classNames from "classnames";

function LiteTradeNotificationPositionClosed(props) {
    const {assetInstance, order, lotsAmount, margin, pl, price} = props;
    const {getLangPath} = useLangContext();
    const assetDescription = assetInstance.asset.info.description;
    const isBuy = _.toLower(order.side) === LITE_TRADE_POSITION_SIDE.BUY;

    return <div className="d-flex flex-column align-items-center py-3">
        <div className="f28 mt-3">
            <IconAsset symbol={assetInstance.symbol}/>
        </div>
        <h3 className="f20 fw500 mt-2 mb-0 text-center">{getLangPath(
            `lite_version.notifications.${isBuy ? 'bought_asset' : 'sold_asset'}`,
            {asset: assetDescription}
        )}</h3>
        <p className="color-white-60 f16 fw300 mt-2">{assetInstance.symbol}</p>
        <div className={classNames("d-flex f28 fw500 color-white", {
            'positive': pl > 0,
        })}>{pl !== null && amountFormat(pl, 2, '$', false, {withSign: true})}
        </div>
        <div className="f14 mt-2 color-white-60" dangerouslySetInnerHTML={{
            __html: getLangPath('lite_version.notifications.basic_info', {
                lots_amount: amountFormat(Math.abs(lotsAmount) || 0, 2),
                margin: `${amountFormat(Math.abs(margin) || 0, 2)}`,
                order_type: getLangPath(`lite_version.order.types.${_.toLower(order.type)}.price`),
                price: assetInstance.roundAmount(price || 0),
                side: '',
            })
        }}/>
    </div>
}

export default LiteTradeNotificationPositionClosed;
